export const ROLES = {
  ADMIN:   'admin',
  TRAINER: 'trainer',
  STUDENT: 'student',
};

// Where each role lands after a successful login
export const ROLE_DASHBOARDS = {
  admin:   '/admin/dashboard',
  trainer: '/trainer/dashboard',
  student: '/student/dashboard',
};
